module.exports = __webpack_public_path__ + "static/media/merchant.dda092e8.svg";